module.exports = __webpack_public_path__ + "img/pdf_icon.21da9287.svg";